export const POSITION_SHOW_TABS = ['general'] as const;

export type PositionShowTab = (typeof POSITION_SHOW_TABS)[number];

export const POSITION_DEFAULT_TAB: PositionShowTab = 'general';
